export default "//cloud.imgsmail.ru/cloud.mail.ru/146512/img/build/editor/co-edit-alert-popup.jpg";